<template>
  <section class="wrap_pop">
    <div class="popbox_wrap">
      <div class="popbox_cont">
        <h1 class="pop_tit">개인(신용)정보의 제공에 관한 사항</h1>
        <div class="cont_agree">
          <ul class="list_type01">
            <li>
              당사는 「개인정보보호법」 및 「신용정보의 이용 및 보호에 관한
              법률」 에 따라 귀하의 개인(신용)정보를 다음과 같이 제3자에게
              제공하고자 합니다.
            </li>
            <li>
              <ul class="list_type02">
                <li>
                  · 개인(신용)정보를 제공받는 자 :
                  {{ isNaver ? "네이버(주)" : "(주)카카오" }}
                </li>
                <li>· 개인(신용)정보를 제공받는 자의 이용목적 : 본인인증</li>
                <li>· 제공할 개인(신용)정보의 내용 : 성명, 생년월일, 연락처</li>
                <li>
                  · 제공받는자의 보유, 이용기간 : 제공받는 자의 이용목적을
                  달성할때까지(최대 거래종료 후 5년까지)
                </li>
              </ul>
            </li>
            <li>
              <ul class="list_type02">
                <li>
                  ※ 각 제공대상기관 및 이용목적의 구체적인 정보는 당사
                  홈페이지(www.meritzfire.com)에서 확인할 수 있습니다.
                </li>
              </ul>
            </li>
            <li>
              <ul class="list_type02">
                <li>
                  · 거래종료일은 1)보험계약 만기, 해지, 취소, 철회일 또는 소멸일
                  및 2)보험금 청구권 소멸시효 완성일, 채권·채무관계 소멸일 중
                  가장 나중에 도래한 사유를 기준으로 판단합니다.(다만, 만기 등
                  사유발생일 이후라도 만기환급금 또는 해지환급금 등을 수령하지
                  않았거나 상환할 금액이 남아있는 경우, 보험금 지급이
                  진행중이거나 수사·소송이 진행중인 경우 거래종료에 해당하지
                  않습니다.)
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <div class="popbox_btn">
        <!-- <div><button type="button" class="btn color2">취소</button></div> -->
        <div>
          <button type="button" class="btn color1" @click="$emit('close')">
            확인
          </button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    isNaver: Boolean,
  },
};
</script>
